import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './hooks/reportWebVitals';

// Suppress all console output in production builds, or when REACT_APP_SUPPRESS_LOGS=true
const suppressLogs =
  process.env.NODE_ENV === 'production' ||
  process.env.REACT_APP_SUPPRESS_LOGS === 'true';

if (suppressLogs) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // console.error is intentionally kept for real runtime errors
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
